import { useEffect } from "react";
import { holdChatSubscription } from "./chatSubscriptions";

/** Holds the chat's subscription while mounted: memory, then this browser's
 * cache, then the relay's tail and a bounded replay from the coverage cursor
 * (see `chatSubscriptions`). `worktreeId`, when given, also follows the
 * worker's provisional tail when it runs on this machine. */
export function useChatSubscription(chatId: string, worktreeId?: string) {
  useEffect(() => holdChatSubscription(chatId, { worktreeId }), [chatId, worktreeId]);
}

/** Keeps every listed chat subscribed while mounted: the chats with a run
 * going in the open worktree, so switching to one of them needs no replay. */
export function useBackgroundChatSubscriptions(chatIds: readonly string[], worktreeId?: string) {
  const key = [...chatIds].sort().join(",");
  useEffect(() => {
    if (!key) return;
    const releases = key.split(",").map((chatId) => holdChatSubscription(chatId, { worktreeId }));
    return () => { for (const release of releases) release(); };
  }, [key, worktreeId]);
}
